import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/dialog';

export type ConfirmModalSimpleProps = {
  visible: boolean;
  message?: string;
  submitInProgress?: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export const ConfirmModalSimple: React.FC<
  React.PropsWithChildren<ConfirmModalSimpleProps>
> = ({
  visible,
  submitInProgress,
  onClose,
  message,
  onSubmit,
}: ConfirmModalSimpleProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={visible}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}>
      {/* 300px matches Bootstrap's size="sm" modal used before the swap */}
      <DialogContent className="tw:max-w-[300px]" aria-describedby={undefined}>
        <DialogBody>
          <DialogTitle className="tw:text-[0.9375rem] tw:font-normal tw:leading-normal tw:mb-0">
            {message ?? t('form.general.defaultConfirmationText')}
          </DialogTitle>
        </DialogBody>
        <DialogFooter>
          <Button size="sm" variant="outline-secondary" onClick={onClose}>
            {t('form.general.cancelButton')}
          </Button>
          <Button size="sm" disabled={submitInProgress} onClick={onSubmit}>
            {submitInProgress ? (
              <span
                className="spinner-border spinner-border-sm tw:me-2"
                role="status"
                aria-hidden="true"
              />
            ) : null}
            {t('form.general.confirmButton')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
